import { Redirect } from 'react-router-dom';
import { useHelpCategories } from '~/components/Help/Help.hooks';

export const HelpCategoryRedirect = () => {
  const { data = [] } = useHelpCategories();
  const categoryId = data[0]?.categoryId;
  return <>{!!categoryId && <Redirect to={`/support/help/category/${categoryId}`} />}</>;
};
